import { call, get } from 'vuex-pathify';
export default {
  computed: {
    isOrdersModuleEnabled: get('admin/additionalModules@ORDERS_MODULE.enabled'),
    isOrdersSettingEnabled: get('admin/settingsValues@orders_module_enabled'),
    ordersLayersId: get('admin/modulesMapping@orders.settings.layer_id'),
    ordersDataSourceName() {
      return this.layers[this.ordersLayersId]?.data_source_name;
    },
    hasOrdersPermissions() {
      return this.$store.get('users/toolsPermissions')['ORDERS_MODULE'].main_value > 0;
    },
    isOrders() {
      return (
        this.currentLayer?.data_source_name !== this.ordersDataSourceName &&
        this.isOrdersModuleEnabled &&
        this.isOrdersSettingEnabled &&
        this.hasOrdersPermissions
      );
    },
    ordersButton() {
      return this.isOrders
        ? [
            {
              name: 'orders',
              icon: '$createTask',
              tooltip: this.isAnyFeatureSelected
                ? this.$i18n.t('sidebar.orders.addOrder')
                : this.$i18n.t('button.toUseTool', {
                    suffix: this.$i18n.t('button.atLeastOneSelected'),
                  }),
              fontSize: '19px',
              disabled: !this.isAnyFeatureSelected,
            },
          ]
        : [];
    },
    ordersDialog() {
      return {
        title: this.$i18n.t('sidebar.orders.addNewOrder'),
        featureData: {
          layer: this.ordersLayersId,
          datasource: this.ordersDataSourceName,
        },
        dialogData: {
          dialogWidth: '29%',
        },
      };
    },
  },
  data: () => ({
    isOrdersLoaded: false,
    isOrdersVisible: false,
  }),
  methods: {
    addRelation: call('relations/addRelation'),
    ordersAction() {
      this.isOrdersLoaded = true;
      this.isOrdersVisible = true;
    },
    async onOrdersDone(closeFunction, featureData, newFeatureId) {
      try {
        await this.addRelation({
          data_source_name: this.ordersDataSourceName,
          feature_id: newFeatureId,
          features: this.currentLayerSelectedFeatures.map(ft => {
            return {
              data_source_name: this.currentLayer?.data_source_name,
              feature_id: ft,
            };
          }),
        });
      } catch {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.ordersRelationError'),
        });
      } finally {
        closeFunction();
      }
    },
  },
};
